import React, { useState } from 'react';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../../config/firebase.js';
import logger from '../../../utils/logger';

export function InlineRating({ document, oneCollection, docMain, twoCollection }) {
  const [currentRating, setCurrentRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);
  const [average, setAverage] = useState(
    document.rating && document.ratingAmount
      ? (document.rating / document.ratingAmount).toFixed(1)
      : null
  );
  const [count, setCount] = useState(document.ratingAmount || 0);

  const handleRate = async (rating) => {
    try {
      const newTotal = (document.rating || 0) + rating;
      const newAmount = (document.ratingAmount || 0) + 1;
      const newAverage = newTotal / newAmount;

      const docRef = doc(db, oneCollection, docMain, twoCollection, document.id);
      await updateDoc(docRef, {
        rating: newTotal,
        ratingAmount: newAmount,
      });

      setCurrentRating(rating);
      setAverage(newAverage.toFixed(1));
      setCount(newAmount);
      document.rating = newTotal;
      document.ratingAmount = newAmount;
    } catch (err) {
      logger.error('Error updating rating:', err);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center text-center">
      <div className="flex mb-1">
        {[...Array(5)].map((_, index) => {
          const starValue = index + 1;
          const isFilled = starValue <= (hoverRating || currentRating);
          return (
            <span
              key={starValue}
              className={`cursor-pointer mx-0.5 text-2xl transition-colors duration-200 ${
                isFilled ? 'text-yellow-400' : 'text-gray-400'
              }`}
              onMouseEnter={() => setHoverRating(starValue)}
              onMouseLeave={() => setHoverRating(0)}
              onClick={() => handleRate(starValue)}
            >
              ★
            </span>
          );
        })}
      </div>
      <div className="text-base font-medium text-gray-700">
        {average ? `${average} ${count ? `(${count})` : ''}` : 'Unrated'}
      </div>
    </div>
  );
}
